import('./bootstrap')
  .catch((err) => console.error("Error encountered while bootstrapping [admin]: ", err))